<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "Unique Profile Config" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current unique profile config." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'Unique Profile Config'" style="height: 410px">
          <!--操作按钮-->
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="clkAdd()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-plus page-tableaction"></i>
                </div>
                <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
                <div
                  @click="clkDel()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-trash-o page-tableaction"></i>
                </div>
              </div>
            </span>
            <label style="float: right; display: flex">
              <span class="input-group-addon tablesearch-box">
                <i class="fa fa-search"></i>
              </span>
              <input
                type="search"
                v-model="searchInfo"
                class="form-control"
                placeholder="search with keywords.."
                style="border-radius: 0px"
              />
            </label>
          </div>

          <!--数据显示-->
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAll"
                  />
                  <label for="idSelectAll"></label>
                </th>
                <th
                  v-for="(value, key) in uniqueProfileTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, index) in uniqueProfileFilter"
                :key="row.profileid"
                :class="{ 'true:': true }"
                @click=""
              >
                <td width="40px">
                  <div v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelect' + index"
                    />
                    <label :for="'idRowSelect' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.ontid }}</div>
                </td>
                <td>
                  <div>{{ row.name }}</div>
                </td>
                <td>
                  <div>{{ row.desc }}</div>
                </td>
                <td>
                  <div>{{ row.alarm }}</div>
                </td>
                <td>
                  <div>{{ row.multicast }}</div>
                </td>
                <td>
                  <div
                    @click="ontUniqueConfig(row.ontid)"
                    class="btn"
                    :class="{ disabled: false }"
                    style="padding: 0px"
                  >
                    <i class="fa fa-external-link page-tableaction"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!--配置-->
          <div v-if="isShowAddTable">
            <dialog-box
              :btitle="'Unique Profile Edit'"
              @close="isShowAddTable = false"
              :closeButton="true"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="profileId"
                    >Profile ONT</label
                  >
                  <div
                    class="col-sm-5"
                    :class="{ 'has-error': profile_ontid_check() }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="profileId"
                      :disabled="isEditClik"
                      v-model="uniqueForm.ontid"
                      placeholder="slot/pon/ont"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: profile_ontid_check() ? 'block' : 'none',
                      }"
                      >{{ profile_ontid_check() }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="name"
                    >Profile Name</label
                  >
                  <div class="col-sm-5" :class="{ 'has-error': checkName() }">
                    <input
                      type="text"
                      class="form-control"
                      id="name"
                      v-model="uniqueForm.name"
                      placeholder="STRING<1-128>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkName() ? 'block' : 'none',
                      }"
                      >{{ checkName() }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="rxlow"
                    >Description</label
                  >
                  <div class="col-sm-5" :class="{ 'has-error': checkDesc() }">
                    <input
                      type="text"
                      class="form-control"
                      id="rxlow"
                      v-model="uniqueForm.desc"
                      placeholder="STRING<1-128>"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkDesc() ? 'block' : 'none',
                      }"
                      >{{ checkDesc() }}
                    </small>
                  </div>
                </div>

                <div class="form-group">
                  <label class="col-sm-3 control-label" for="alarmprofile"
                    >Alarm ProfileID</label
                  >
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      id="alarmprofile"
                      v-model="uniqueForm.alarm"
                    >
                      <option value="">None</option>
                      <option
                        v-for="data in alarmProfileTable"
                        :key="data.profileid"
                        :value="data.profileid"
                      >
                        {{ data.profileid + ":" + data.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="multicastprofile"
                    >Multicast ProfileID</label
                  >
                  <div class="col-sm-5">
                    <select
                      class="form-control"
                      id="multicastprofile"
                      v-model="uniqueForm.multicast"
                    >
                      <option value="">None</option>
                      <option
                        v-for="data in multicastProfileTable"
                        :key="data.profileid"
                        :value="data.profileid"
                      >
                        {{ data.profileid + ":" + data.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "profileUnique",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  data() {
    return {
      isShowAddTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      uniqueForm: {
        ontid: "",
        name: "",
        desc: "",
        alarm: "",
        multicast: "",
      },
      uniqueProfileTable: "",
      alarmProfileTable: "",
      multicastProfileTable: "",
      searchInfo: "",
    }
  },
  created() {
    this.loadUniqueProfile()
    this.loadAlarmProfile()
    this.loadMulticastProfile()
  },
  methods: {
    loadUniqueProfile() {
      get("uniqueProfile")
        .then((res) => (this.uniqueProfileTable = res.data))
        .catch((err) => {
          this.uniqueProfileTable = en.uniqueProfileTable
        })
    },
    loadAlarmProfile() {
      get("alarmProfile")
        .then((res) => (this.alarmProfileTable = res.data.data))
        .catch((err) => {})
    },
    loadMulticastProfile() {
      get("multicastProfile")
        .then((res) => (this.multicastProfileTable = res.data.data))
        .catch((err) => {})
    },

    ontUniqueConfig(ontId) {
      this.$router.push({
        path: "/profileuniqueconfig",
        name: "profileUniqueConfig",
        query: { uniqueOntIndex: ontId },
      })
    },
    clkAdd() {
      this.isShowAddTable = true
      this.isEditClik = false
      this.resetField()
      this.selectNull()
    },

    clkEdit() {
      for (let i = 0; i < this.uniqueProfileTable.data.length; i++) {
        if (this.uniqueProfileTable.data[i].selected) {
          this.uniqueForm.ontid = this.uniqueProfileTable.data[i].ontid
          if (this.uniqueProfileTable.data[i].name.match(/^INDEX_/) == null) {
            this.uniqueForm.name = this.uniqueProfileTable.data[i].name
          }
          this.uniqueForm.desc = this.uniqueProfileTable.data[i].desc
          this.uniqueForm.alarm = this.uniqueProfileTable.data[i].alarm
          this.uniqueForm.multicast = this.uniqueProfileTable.data[i].multicast
          this.isShowAddTable = true
          this.isEditClik = true
          return
        }
      }
    },

    clkDel() {
      var delData = {}
      var list = []

      for (let i = 0; i < this.uniqueProfileTable.data.length; i++) {
        if (this.uniqueProfileTable.data[i].selected) {
          list.push({ ontID: this.uniqueProfileTable.data[i].ontid })
        }
      }
      if (list.length == 0) {
        return
      }

      delData["ontList"] = list
      post("uniqueProfileDelete", delData)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadUniqueProfile()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else {
            this.loadUniqueProfile()
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },

    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var uniqueFormTmp = {
        ontid: "",
        name: "",
        desc: "",
        alarm: "",
        multicast: "",
      }
      this.uniqueForm = uniqueFormTmp
    },

    changeSelectAll() {
      for (let i = 0; i < this.uniqueProfileFilter.length; i++) {
        if (this.isSelectAll) {
          this.uniqueProfileFilter[i].selected = true
        } else {
          this.uniqueProfileFilter[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.uniqueProfileTable.data.length; i++) {
        this.uniqueProfileTable.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var uniqueProfile = {
        ontid: this.uniqueForm.ontid,
        name: this.uniqueForm.name,
        desc: this.uniqueForm.desc,
        alarm: Number(this.uniqueForm.alarm),
        multicast: Number(this.uniqueForm.multicast),
      }
      if (this.isEditClik == false) {
        for (let i = 0; i < this.uniqueProfileTable.data.length; i++) {
          if (uniqueProfile.ontid == this.uniqueProfileTable.data[i].ontid) {
            this.showAlertBox("warn", "Message", "This ONT ID has been created")
            return
          }
        }
      }
      if (this.uniqueForm.ontid == "") {
        this.showAlertBox("warn", "Message", "Invalid ontID")
        return
      }
      if (this.uniqueForm.name.length > 128 || this.checkName()) {
        this.showAlertBox("warn", "Message", "Invalid name")
        return
      }
      if (this.uniqueForm.desc.length > 128 || this.checkDesc()) {
        this.showAlertBox("warn", "Message", "Invalid description")
        return
      }
      if (this.uniqueForm.alarm == "") {
        uniqueProfile.alarm = 0xff
      }
      if (this.uniqueForm.multicast == "") {
        uniqueProfile.multicast = 0xff
      }

      post("uniqueProfileConfig", uniqueProfile)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadUniqueProfile()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else {
            this.loadUniqueProfile()
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.isEditClik = false
      this.selectNull()
    },

    profile_ontid_check(value) {
      if (this.uniqueForm.ontid != "") {
        if (
          this.uniqueForm.ontid.match(/0\/[1-9][0-9]?\/[1-9][0-9]?[0-9]?$/) ==
          null
        ) {
          return "id must be inputted with slot<0-0>/pon<1-16>/ont<1-128> "
        } else {
          var id = this.uniqueForm.ontid.split("/")
          let slot = Number(id[0])
          let port = Number(id[1])
          let ont = Number(id[2])
          if (slot != 0 || port > 16 || ont > 128) {
            return "id must be inputted with slot<0-0>/pon<1-16>/ont<1-128> "
          }
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
    checkName() {
      if (nonASCIIchar(this.uniqueForm.name)) {
        return nonASCIIchar(this.uniqueForm.name)
      }
      if (this.uniqueForm.name.split(" ").length > 1) {
        return "invalid name"
      }
      return null
    },
    checkDesc() {
      if (nonASCIIchar(this.uniqueForm.desc)) {
        return nonASCIIchar(this.uniqueForm.desc)
      }
      if (this.uniqueForm.desc.split(" ").length > 1) {
        return "invalid description"
      }
      return null
    },
  },
  computed: {
    uniqueProfileFilter() {
      var profileTable = []
      if (this.uniqueProfileTable.data !== undefined)
        this.uniqueProfileTable.data.forEach((element) => {
          for (const key in element) {
            if (
              this.searchInfo === "" ||
              (typeof element[key] === "string" &&
                element[key].indexOf(this.searchInfo) !== -1)
            ) {
              profileTable.push(element)
              break
            }
          }
        })
      return profileTable
    },
  },
}
</script>
